import React from 'react'
import Login from 'components/LoginUser'

export default function LoginScreen (path) {
    return (
      <Login path={path} />
    )
}
